import {
  BundleItemInput,
  BundleItemType as GqlBundleItemType,
  BundleStatus,
  CreateOtpBundleInput,
  UpdateOtpBundleInput,
  InAppPurchase,
} from 'generated/graphql';
import { BundleFormValues } from './editOtpBundle.vm';
import { convertDollarsToCents } from '../../common/bundles.mapper';
import { isEmpty } from 'lodash';

export const validateContentForPublish = (
  programs: number[],
  features: number[],
  content: string[],
): string | undefined => {
  if (isEmpty(programs) && isEmpty(features) && isEmpty(content)) {
    return 'Offer must contain at least one item from following categories: Programs, Features, Content items';
  }
};

export const toUpdateBundlePayload = (
  bundleId: number,
  formValues: BundleFormValues,
  bundleStatus: BundleStatus,
  isAdmin: boolean,
): UpdateOtpBundleInput => {
  const creatorsPayload = {
    id: bundleId,
    title: formValues.name,
    priceInCents:
      !formValues.isFree && formValues.price
        ? convertDollarsToCents(formValues.price)
        : null,
    status: bundleStatus,
    description: formValues.description || null,
    items: toPayloadItems(formValues),
    isFree: formValues.isFree,
    inAppPurchase: formValues.allowInAppPurchase
      ? InAppPurchase.Allow
      : InAppPurchase.Hide,
    coverImage: formValues.coverImage ?? null,
  };

  if (!isAdmin) return creatorsPayload;

  return {
    ...creatorsPayload,
    playbookFeePercent: formValues.isFree ? null : formValues.playbookFee,
  };
};

export const toCreateBundlePayload = (
  influencerId: number,
  formValues: BundleFormValues,
  status?: BundleStatus,
): CreateOtpBundleInput => {
  return {
    influencerId,
    title: formValues.name,
    priceInCents:
      !formValues.isFree && formValues.price
        ? convertDollarsToCents(formValues.price)
        : null,
    status: status || BundleStatus.Draft,
    description: formValues.description || null,
    items: toPayloadItems(formValues),
    isFree: formValues.isFree,
    inAppPurchase: formValues.allowInAppPurchase
      ? InAppPurchase.Allow
      : InAppPurchase.Hide,
    coverImage: formValues.coverImage ?? null,
  };
};

const toPayloadItems = (formValues: BundleFormValues): BundleItemInput[] => {
  const content = (formValues.content || []).map((id) => ({
    contentId: id,
    itemType: GqlBundleItemType.Content,
  }));
  const programs = (formValues.programs || []).map((id) => ({
    itemId: id,
    itemType: GqlBundleItemType.Program,
  }));
  const features = (formValues.features || []).map((id) => ({
    itemId: id,
    itemType: GqlBundleItemType.Feature,
  }));

  return [...content, ...programs, ...features];
};
